import cleanDeep from 'clean-deep';
import { API, graphqlOperation } from 'aws-amplify';

import {
  deleteTeam,
  createTeam,
  updateTeam,
} from '../graphql/mutations';

import {
  getTeamByCompany,
} from '../graphql/queries';

export const createTeamRecord = (params) => API.graphql(
  graphqlOperation(createTeam, { input: cleanDeep(params) }),
);

export const updateTeamRecord = (params) => API.graphql(
  graphqlOperation(updateTeam, { input: cleanDeep(params) }),
);

export const deleteTeamRecord = (params) => API.graphql(
  graphqlOperation(deleteTeam, { input: cleanDeep(params) }),
);

export const getTeamRecordsByCompany = (companyId) => API.graphql(
  graphqlOperation(getTeamByCompany, { companyId }),
);
